import Loader from '@byma/shared/components/Loader'
import Input from '@byma/shared/components/Input'
import { useState } from 'react'
import useAuth from '@byma/shared/hooks/useAuth'
import dayjs from 'dayjs'
import useSWR, { useSWRConfig } from 'swr'
import fetcher from '@byma/shared/helpers/fetcher'
function toQueryString(obj, forceKey=null) {
    return Object.keys(obj).map(function (key) {
        if (typeof obj[key] === 'object') {
            return toQueryString(obj[key], key)
        }
        return (forceKey || key) + '=' + obj[key]
    }).join('&');
}
function EventItem({event, active=false, noCheckbox=false}) {
    return (
        <div className={`flex items-center cursor-pointer box box-hover ${active && 'box-active'} space-x-3 mb-0`}>
            {!noCheckbox && (
                <input type="checkbox" checked={active} readOnly />
            )}
            { event?.pictures?.photos[0] ? (
                <img src={event.pictures.photos[0]} alt={event.name} className="rounded-full w-12 h-12 object-cover" />
            ) : (
                <div className="w-12 h-12 rounded-full bg-gray-400 overflow-hidden" />
            ) }
            <div className="">
                <p className="text-md font-bold">{event.name}</p>
                <p className="text-sm">{dayjs(event.date).format('DD/MM/YYYY [às] hh:mm')}</p>
            </div>
        </div>
    )
}
export default function EventSelector({selectedEvent, onChange, eventIds='', fromDate='', toDate=''}) {
    const session = useAuth()
    const { token, user: currentUser } = session
    const [searchQuery, setSearchQuery] = useState('')
    const { data: parties } = useSWR(token ? [`/api/parties/getAll?${toQueryString({search: searchQuery, perPage: 30, partyIds: eventIds, fromDate, toDate})}`, null, token] : null, fetcher)

    async function handleSearch(e) {
        e.stopPropagation()
        e.preventDefault()
        setSearchQuery(e.currentTarget.search.value)
        return false
    }
    if (selectedEvent) {
        return (
                <div className="box flex space-x-2 justify-between items-center">
                    <div className="w-full">
                        <EventItem event={selectedEvent} noCheckbox/>
                    </div>
                    <button className="btn" onClick={() => onChange(null)}>
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                        </svg>
                    </button>
                </div>
        )
    }

    return (
        <div className="flex flex-col justify-between p-3 space-y-3 h-96 overflow-y-auto box w-full">

            <form onSubmit={handleSearch}>
                <Input size="s" name="search" type="text" label={(
                    <div className="flex space-x-2 items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
                        </svg>
                        <p>Buscar eventos...</p>
                    </div>
                )} />
            </form>
            <div className="overflow-y-auto flex-grow flex-shrink h-full">
                <div className="flex flex-col h-full space-y-3">
                    { parties ? parties.result.map(party => (
                        <div onClick={() => onChange(party)}>
                            <EventItem event={party} active={selectedEvent?._id === party._id} />
                        </div>
                    )) : <Loader />}
                    { parties && parties.result.length === 0 && (
                        <div className="text-center box bg-yellow-50">
                            <p>
                                A antecipação de recebíveis é um recurso para o pré-evento. O saldo remanescente do pós evento é programado de acordo com o seu fechamento financeiro e a relação contratual.
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}
